export const EMAIL_CONFIG_OPTIONS = [
  { name: 'confirmation', label: 'Confirmação' },
  { name: 'cancelling', label: 'Cancelamento/Remoção' },
  { name: 'd0', label: 'Lembrete no dia' },
  { name: 'd1', label: 'Lembrete um dia antes' },
  { name: 'd2', label: 'Lembrete dois dias antes' }
];

export const formatEmailConfigValues = (values = {}) => (
  EMAIL_CONFIG_OPTIONS.reduce((acc, { name }) => {
    acc[name] = +values[name] ? 1 : 0;
    return acc;
  }, {})
);